export const NO_ACTIVITY_HISTORY_STRING =
  'Student has not yet launched any activities';

export const EXPORT_ACTIVITY_LOG_STRING = 'Export Activity Log';

export const LAST_ACTIVITY_LAUNCHED_STRING = 'Last Activity Launched:';

export const COURSE_LEVEL_ACTIVITIES_UNIT_ID = 'course-level-activities';
